import Button from '../../../../components/Button'
import useResize from '../../../../hooks/useResize'
import { VIEWPORT_LG } from '../../../../utils/constants'

const TabBar = ({ tabBarValue, setTabBarValue }) => {
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG
  const handleButtonClick = (button) => {
    setTabBarValue(button)
  }

  return (
    <div
      className="bg-on-bg-brand p-2 rounded gap-2"
      style={{
        width: 'max-content',
      }}
    >
      <div className="d-flex justify-content-center align-items-center overflow-auto">
        <Button
          className={`${
            tabBarValue === 'Pendientes'
              ? 'bg-bg-CTA-primary'
              : 'bg-on-bg-brand'
          } text-on-bg-primary ${isMobile ? 'font-extra-small' : 'font-small'}`}
          onClick={() => handleButtonClick('Pendientes')}
        >
          {'Pendientes'}
        </Button>
        <Button
          className={`${
            tabBarValue === 'Aprobados' ? 'bg-bg-CTA-primary' : 'bg-on-bg-brand'
          } text-on-bg-primary ${isMobile ? 'font-extra-small' : 'font-small'}`}
          onClick={() => handleButtonClick('Aprobados')}
        >
          {'Aprobados'}
        </Button>
        <Button
          className={`${
            tabBarValue === 'Rechazados'
              ? 'bg-bg-CTA-primary'
              : 'bg-on-bg-brand'
          } text-on-bg-primary ${isMobile ? 'font-extra-small' : 'font-small'}`}
          onClick={() => handleButtonClick('Rechazados')}
        >
          {'Rechazados'}
        </Button>
      </div>
    </div>
  )
}

export default TabBar
